import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RouteModel} from "../../../routes/models/route.model";

@Injectable({providedIn: 'root'})
export class RoutesHttpService {

  private base_url = `/leanPlanning/routes`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getRoutes(params?: any): Observable<{ list: RouteModel[], cursor?: string }> {
    return this.http.get<{ list: RouteModel[], cursor?: string }>(this.base_url, {params});
  }

}
